import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import colors from '../../styles/export.module.scss.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import Icon from '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import 'classnames';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../services/ipcWeb/ipcService.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './VoiceTestComponent.module.scss.js';
import { useVoiceTest, VoiceTestState } from './useVoiceTest.js';

function VoiceTestComponent(_ref) {
  var client = _ref.client,
    giid = _ref.giid,
    deviceLabel = _ref.deviceLabel,
    onStateChanged = _ref.onStateChanged,
    interval = _ref.interval,
    maxTestTime = _ref.maxTestTime,
    maxNumberOfFailures = _ref.maxNumberOfFailures;
  var _useVoiceTest = useVoiceTest(client, giid, deviceLabel, interval, maxTestTime),
    startTest = _useVoiceTest.startTest,
    testState = _useVoiceTest.testState;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    testStarted = _useState2[0],
    setTestStarted = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    numberOfFailures = _useState4[0],
    setNumberOfFailures = _useState4[1];
  var successParam = {
    title: 'MPLIB_VOICE_TEST_SUCCESS_TITLE',
    text: 'MPLIB_VOICE_TEST_SUCCESS_DESCRIPTION',
    color: colors.green,
    icon: 'icon-completed'
  };
  var failedParam = {
    title: 'MPLIB_VOICE_TEST_FAILED_TITLE',
    text: 'MPLIB_VOICE_TEST_FAILED_DESCRIPTION',
    color: colors.red,
    icon: 'icon-failed'
  };
  var timeoutParam = {
    title: 'MPLIB_VOICE_TEST_TIMEOUT_TITLE',
    text: 'MPLIB_VOICE_TEST_TIMEOUT_DESCRIPTION',
    color: colors.red,
    icon: 'icon-failed'
  };
  var errorParam = {
    title: 'MPLIB_VOICE_TEST_ERROR_TITLE',
    text: 'MPLIB_VOICE_TEST_ERROR_DESCRIPTION',
    color: colors.red,
    icon: 'icon-failed'
  };
  var contactParam = {
    title: 'MPLIB_VOICE_TEST_CONTACT_CUSTOMER_SUPPORT_TITLE',
    text: 'MPLIB_VOICE_TEST_CONTACT_CUSTOMER_SUPPORT_DESCRIPTION',
    color: colors.red,
    icon: 'icon-failed'
  };
  var notReadyParam = {
    title: 'MPLIB_VOICE_TEST_NOT_READY_TITLE',
    text: 'MPLIB_VOICE_TEST_NOT_READY_DESCRIPTION',
    color: colors.red,
    icon: 'icon-failed'
  };
  useEffect(function () {
    if (!testStarted) {
      setTestStarted(true);
      startTest();
    }
  }, [startTest, testStarted]);
  var Started = function Started() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.voiceTestItem
    }, /*#__PURE__*/React.createElement(LoadingSpinner, {
      dataTestId: "polling-spinner-voice-test",
      relative: true,
      isLoading: true,
      centered: true,
      size: "medium",
      className: styles.spinner
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.voiceTestTitle
    }, t('MPLIB_EXECUTING_VOICE_TEST_TITLE')), /*#__PURE__*/React.createElement("div", {
      className: styles.text
    }, t('MPLIB_EXECUTING_VOICE_TEST_TEXT'))));
  };
  useEffect(function () {
    if ([VoiceTestState.FAILED, VoiceTestState.TIMEOUT, VoiceTestState.ERROR].includes(testState)) {
      setNumberOfFailures(function (previous) {
        return previous + 1;
      });
    }
    onStateChanged(testState);
  }, [testState]);
  var RetryButton = function RetryButton() {
    return /*#__PURE__*/React.createElement(Button, {
      dataTestId: "startVoiceTest",
      text: t('MPLIB_VOICE_TEST_RETRY_VOICE_TEST'),
      onClick: startTest,
      className: styles.cancelScanButton,
      flat: true
    });
  };
  var voiceTestLabelComponent = function voiceTestLabelComponent(voiceObject) {
    var title = voiceObject.title,
      icon = voiceObject.icon,
      text = voiceObject.text,
      color = voiceObject.color;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.voiceTestItem
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.icon
    }, /*#__PURE__*/React.createElement(Icon, {
      dataTestId: "voice-test-failed",
      icon: icon,
      size: "xlarge",
      color: color
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.voiceTestTitle
    }, t(title)), /*#__PURE__*/React.createElement("div", {
      className: styles.text
    }, t(text))), /*#__PURE__*/React.createElement("section", {
      className: styles.cancelScan
    }, /*#__PURE__*/React.createElement(RetryButton, null)));
  };
  if (testState.state === VoiceTestState.NOT_READY) {
    return voiceTestLabelComponent(notReadyParam);
  }
  if (numberOfFailures >= maxNumberOfFailures && ![VoiceTestState.STARTED, VoiceTestState.SUCCESS].includes(testState.state)) {
    return voiceTestLabelComponent(contactParam);
  }
  if (testState.state === VoiceTestState.SUCCESS) {
    return voiceTestLabelComponent(successParam);
  }
  if (testState.state === VoiceTestState.FAILED) {
    return voiceTestLabelComponent(failedParam);
  }
  if (testState.state === VoiceTestState.TIMEOUT) {
    return voiceTestLabelComponent(timeoutParam);
  }
  if (testState.state === VoiceTestState.ERROR) {
    return voiceTestLabelComponent(errorParam);
  }
  return /*#__PURE__*/React.createElement(Started, null);
}
VoiceTestComponent.propTypes = {
  client: PropTypes.shape({}).isRequired,
  giid: PropTypes.string.isRequired,
  deviceLabel: PropTypes.string.isRequired,
  onStateChanged: PropTypes.func,
  interval: PropTypes.number,
  maxTestTime: PropTypes.number,
  maxNumberOfFailures: PropTypes.number
};
VoiceTestComponent.defaultProps = {
  onStateChanged: function onStateChanged() {},
  interval: 10000,
  maxTestTime: 120000,
  maxNumberOfFailures: 2
};

export { VoiceTestComponent as default };
